// extracted by mini-css-extract-plugin
module.exports = {"container":"conferenceView_container__3tB4Q","iframe":"conferenceView_iframe__1mOZt"};